import {MatrixFiller} from "./services/matrix_filler";
import {onlyUnique} from "../../helpers/array";

export class GridItemsModel {
    constructor(items, props = {}) {
        this.items = items;
        this.fillerCollectionInserts = props.hasOwnProperty('fillerCollectionInserts') ? props['fillerCollectionInserts'] : null;
        this.matrix = null;

        let columnCount = props.hasOwnProperty('columnCount') ? props['columnCount'] : null;
        this.setColumnCount(columnCount);
    }

    // When the column count changes we also update the column count for child items.
    // This causes them to update there column span values.
    // We can then rebuild the grid model.
    setColumnCount(newColumnCount) {
        if (newColumnCount === this.columnCount) return;
        this.columnCount = newColumnCount;
        this.updateSpans();
        this.matrix = this.buildMatrix();
    }

    updateSpans() {
        this.items.forEach((item) => {
            item.setColumnCount(this.columnCount);
        })
    }

    buildMatrix() {
        if (!this.columnCount || this.columnCount < 1) return null;
        return new MatrixFiller(this.columnCount, this.items, {'fillers': this.fillerCollectionInserts}).getMatrix();
    }

    getMatrixElements() {
        if (!this.matrix) return;
        let elements = [];
        this.matrix.forEach((row, rowIndex) => {
            row.forEach((cell, columnIndex) => {
                if (typeof cell !== 'undefined') {
                    elements.push(cell.element);
                }
            });
        });
        // Only get unique elements!
        return elements.filter(onlyUnique)
    }

}